module.exports = __webpack_public_path__ + "static/media/ethos.5f5b3e25.svg";